module.exports = require('./helpers/bundle-url').getBundleURL('drLhz') + "../assets/images/de.027e60c8.png";